import * as React from 'react';
import { Box, Container, Grid, Typography, Button } from '@mui/material';
import { Link } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { loginWithGoogle } from '../auth/AuthSlice';

function Footer() {
    const dispatch = useDispatch();

    const handleLogin = () => dispatch(loginWithGoogle());

    return (
        <Box sx={{
            backgroundColor: '#2c3e50',
            color: 'white',
            py: 8,
            px: 4,
            position: 'relative',
            zIndex: 2
        }}>
            <Container maxWidth="lg">
                <Grid container spacing={4}>
                    {/* Logo and Brand */}
                    <Grid item xs={12} md={4}>
                        <Box sx={{ display: 'flex', alignItems: 'center', mb: 3 }}>
                            <Box
                                component="img"
                                src="/icon.svg"
                                sx={{
                                    width: 60,
                                    height: 60,
                                    mr: 2
                                }}
                            />
                            <Typography variant="h4" sx={{
                                fontWeight: 700
                            }}>
                                CueMeUp
                            </Typography>
                        </Box>
                        <Typography variant="body2" sx={{ mb: 3, opacity: 0.8 }}>
                            Seamlessly create, customize, and download elevation cue cards for your adventures
                        </Typography>
                        <Box sx={{ mt: 2 }}>
                            <Typography variant="body2" sx={{ opacity: 0.7, mb: 1 }}>
                                In Partnership With
                            </Typography>
                            <Box
                                component="a"
                                href="https://acier.cc"
                                target="_blank"
                                rel="noopener noreferrer"
                                sx={{
                                    color: 'white',
                                    textDecoration: 'none',
                                    '&:hover': { opacity: 0.8 },
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: 1
                                }}
                            >
                                <Box
                                    component="img"
                                    src="/acier_logo_full.jpg"
                                    alt="Acier"
                                    sx={{
                                        height: 40,
                                        width: 'auto'
                                    }}
                                />
                                <Typography variant="h6" sx={{ fontWeight: 600 }}>
                                    Acier.cc
                                </Typography>
                            </Box>
                        </Box>
                    </Grid>

                    {/* Quick Links */}
                    <Grid item xs={12} sm={6} md={2}>
                        <Typography variant="h6" sx={{ mb: 2, fontWeight: 600 }}>
                            Product
                        </Typography>
                        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
                            <Link to="/pricing" style={{ color: 'white', textDecoration: 'none' }}>
                                <Typography variant="body2" sx={{ '&:hover': { opacity: 0.8 } }}>Pricing</Typography>
                            </Link>
                            <Link to="/updates" style={{ color: 'white', textDecoration: 'none' }}>
                                <Typography variant="body2" sx={{ '&:hover': { opacity: 0.8 } }}>Updates</Typography>
                            </Link>
                            <Link to="/integrations" style={{ color: 'white', textDecoration: 'none' }}>
                                <Typography variant="body2" sx={{ '&:hover': { opacity: 0.8 } }}>Integrations</Typography>
                            </Link>
                            <Link to="/help" style={{ color: 'white', textDecoration: 'none' }}>
                                <Typography variant="body2" sx={{ '&:hover': { opacity: 0.8 } }}>Help Center</Typography>
                            </Link>
                        </Box>
                    </Grid>

                    {/* Company */}
                    <Grid item xs={12} sm={6} md={2}>
                        <Typography variant="h6" sx={{ mb: 2, fontWeight: 600 }}>
                            Company
                        </Typography>
                        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
                            <Link to="/about" style={{ color: 'white', textDecoration: 'none' }}>
                                <Typography variant="body2" sx={{ '&:hover': { opacity: 0.8 } }}>About Us</Typography>
                            </Link>
                            <Box
                                component="a"
                                href="mailto:contact@cuemeup.com"
                                sx={{ color: 'white', textDecoration: 'none', '&:hover': { opacity: 0.8 } }}
                            >
                                <Typography variant="body2" sx={{ '&:hover': { opacity: 0.8 } }}>Contact Us</Typography>
                            </Box>
                        </Box>
                    </Grid>

                    {/* Legal */}
                    <Grid item xs={12} sm={6} md={2}>
                        <Typography variant="h6" sx={{ mb: 2, fontWeight: 600 }}>
                            Legal
                        </Typography>
                        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
                            <Link to="/terms" style={{ color: 'white', textDecoration: 'none' }}>
                                <Typography variant="body2" sx={{ '&:hover': { opacity: 0.8 } }}>Terms of Service</Typography>
                            </Link>
                            <Link to="/privacy" style={{ color: 'white', textDecoration: 'none' }}>
                                <Typography variant="body2" sx={{ '&:hover': { opacity: 0.8 } }}>Privacy Policy</Typography>
                            </Link>
                        </Box>
                    </Grid>

                    {/* Social & Partnership */}
                    <Grid item xs={12} sm={6} md={2}>
                        <Typography variant="h6" sx={{ mb: 2, fontWeight: 600 }}>
                            Connect
                        </Typography>
                        <Box sx={{ display: 'flex', gap: 2, mb: 3 }}>
                            <Box
                                component="a"
                                href="https://instagram.com/cue_me_up"
                                target="_blank"
                                rel="noopener noreferrer"
                                sx={{ color: 'white', '&:hover': { opacity: 0.8 } }}
                            >
                                <Typography variant="body2">Instagram</Typography>
                            </Box>
                        </Box>
                        <Button
                            variant="contained"
                            onClick={handleLogin}
                            sx={{
                                backgroundColor: '#FF5722',
                                '&:hover': {
                                    backgroundColor: '#FF5722'
                                },
                                fontWeight: 600,
                                px: 3,
                                py: 1.5
                            }}
                        >
                            Try It Free
                        </Button>
                    </Grid>
                </Grid>

                {/* Bottom Bar */}
                <Box sx={{
                    borderTop: '1px solid rgba(255,255,255,0.1)',
                    mt: 4,
                    pt: 3,
                    textAlign: 'center'
                }}>
                    <Typography variant="body2" sx={{ opacity: 0.7 }}>
                        © 2025 CueMeUp. All rights reserved.
                    </Typography>
                </Box>
            </Container>
        </Box>
    );
}

export default Footer;
